import { ReactNode } from "react";

import { Navigate, useLocation } from "react-router-dom";

import { isRestoreUrl, resolveRestoreUrl, TableRestoreConfig } from "./restore";

interface TableRestoreProps {
    config: TableRestoreConfig;
    children: ReactNode;
}

/** Wraps a list page so a `restore` URL settles on the stored view before the page mounts.*/
export function TableRestore({ config, children }: TableRestoreProps) {
    const location = useLocation();

    if (isRestoreUrl(new URLSearchParams(location.search))) {
        return <Navigate to={resolveRestoreUrl(location, config)} replace />;
    }
    return children;
}
